export default __webpack_public_path__ + "static/media/Helvetica-Light.6e816f78.ttf";